import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function AdmissionBanner() {
	return (
		<motion.section
			initial={{ y: 30, opacity: 0 }}
			whileInView={{ y: 0, opacity: 1 }}
			transition={{ duration: 0.6, ease: "easeOut" }}
			viewport={{ once: true, amount: 0.2 }}
			className="relative py-16 px-4 bg-gradient-to-br from-indigo-950 via-purple-900 to-blue-950 overflow-hidden"
		>
			{/* Background Pattern */}
			<div className="absolute inset-0 opacity-10">
				<div className="absolute top-0 left-0 w-96 h-96 bg-white/20 rounded-full blur-3xl"></div>
				<div className="absolute bottom-0 right-0 w-96 h-96 bg-white/20 rounded-full blur-3xl"></div>
			</div>

			<div className="container mx-auto max-w-7xl relative z-10">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
					
					{/* Left Column: Call to Action */}
					<motion.div
						initial={{ x: -30, opacity: 0 }}
						whileInView={{ x: 0, opacity: 1 }}
						transition={{ delay: 0.2, duration: 0.6 }}
						viewport={{ once: true }}
						className="text-white order-2 lg:order-1"
					>
						<div className="mb-4">
							<span className="inline-block px-4 py-2 bg-green-500 text-white rounded-md text-sm font-bold uppercase tracking-wide shadow-lg" style={{ textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)" }}>
								Admissions Open 2026
							</span>
						</div>

						<h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight" style={{ textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)" }}>
							Enroll Your Child in Excellence
						</h2>

						<p className="text-xl md:text-2xl text-gray-200 mb-6 leading-relaxed">
							Classes Nursery to Class 8
						</p>

						<div className="mb-8 space-y-3">
							<div className="flex items-start gap-3">
								<div className="w-6 h-6 bg-green-500 rounded-full flex-shrink-0 mt-1 flex items-center justify-center">
									<svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
										<path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
									</svg>
								</div>
								<p className="text-lg text-gray-100 font-medium">
									FREE Admission for Nursery & LKG
								</p>
							</div>

							<div className="flex items-start gap-3">
								<div className="w-6 h-6 bg-green-500 rounded-full flex-shrink-0 mt-1 flex items-center justify-center">
									<svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
										<path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
									</svg>
								</div>
								<p className="text-lg text-gray-100 font-medium">
									Experienced & Trained Teachers
								</p>
							</div>

							<div className="flex items-start gap-3">
								<div className="w-6 h-6 bg-green-500 rounded-full flex-shrink-0 mt-1 flex items-center justify-center">
									<svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
										<path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
									</svg>
								</div>
								<p className="text-lg text-gray-100 font-medium">
									Modern Facilities & Infrastructure
								</p>
							</div>

							<div className="flex items-start gap-3">
								<div className="w-6 h-6 bg-green-500 rounded-full flex-shrink-0 mt-1 flex items-center justify-center">
									<svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
										<path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
									</svg>
								</div>
								<p className="text-lg text-gray-100 font-medium">
									Activity-Oriented Learning
								</p>
							</div>
						</div>

						<div className="flex flex-col sm:flex-row gap-4" >
							<Link to="/admission">
								<button className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg font-bold text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
									Apply Now
								</button>
							</Link>
							<Link to="/admission">
								<button className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-sm text-white  border-white/30 rounded-lg font-bold text-lg hover:bg-white/20 transition-all duration-300">
									Learn More
								</button>
							</Link>
						</div>
					</motion.div>

					{/* Right Column: Admission Poster */}
					<motion.div
						initial={{ x: 30, opacity: 0 }}
						whileInView={{ x: 0, opacity: 1 }}
						transition={{ delay: 0.3, duration: 0.6 }}
						viewport={{ once: true }}
						className="order-1 lg:order-2"
					>
						<Link to="/admission" className="block group">
							<div className="relative overflow-hidden rounded-xl shadow-2xl transform group-hover:scale-105 transition-all duration-500">
								{/* Poster Image */}
								<img
									src="/assets/images/admission-2026.jpg"
									alt="Sacred Heart School Admission 2026 - Complete Information"
									className="w-full h-auto object-cover rounded-xl"
									loading="lazy"
								/>
								
								{/* Hover Overlay */}
								<div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl flex items-end justify-center pb-8">
									<span className="text-white text-xl font-bold transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
										View Full Details
									</span>
								</div>
							</div>
						</Link>
					</motion.div>

				</div>
			</div>
		</motion.section>
	);
}
